import { Component, computed, inject, linkedSignal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucideChevronDown, lucideSlash } from '@ng-icons/lucide';

import { HlmBreadCrumbImports } from '@spartan-ng/helm/breadcrumb';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';

import { EtapeStore } from '../../../référentiel-métier-parcours/parcours-etape/store/etape.store';
import { ModuleStore } from '../../../référentiel-métier-parcours/parcours-module/store/module.store';
import { ActivitéStore } from '../../../scénarisation/store/activité.store';
import { TrierParPipe } from '../../pipes/trier-par.pipe';

@Component({
  selector: 'app-breadcrumb-scenarisation',
  imports: [HlmBreadCrumbImports, HlmDropdownMenuImports, TrierParPipe, RouterModule, HlmIconImports],
  templateUrl: './breadcrumb-scenarisation.component.html',
  providers: [provideIcons({ lucideSlash, lucideChevronDown })],
})
export class BreadcrumbScenarisationComponent {
  readonly #moduleStore = inject(ModuleStore);
  readonly #etapeStore = inject(EtapeStore);
  readonly #activiteStore = inject(ActivitéStore);
  readonly #router = inject(Router);
  readonly #route = inject(ActivatedRoute);

  readonly moduleSelected = this.#moduleStore.selectedEntity;
  readonly etape = linkedSignal(() => this.#etapeStore.selectedEntity());
  readonly activite = linkedSignal(() => this.#activiteStore.selectedEntity());
  readonly modules = computed(() => this.etape()?.modules);

  navigateTo(path: string, moduleId?: string) {
    const parcoursPath = [
      'cartographies',
      this.#route.snapshot.params['slugCarto'],
      'référentiels',
      this.#route.snapshot.params['slugRef'],
      'parcours',
      this.#route.snapshot.params['idParcours'],
    ];

    this.#activiteStore.unselect();

    if (path == 'etape') {
      this.#router.navigate(parcoursPath, {
        queryParams: { niveau: '02', id: this.etape()?.id, type: 'étape', detail: true },
      });
    } else {
      this.#router.navigate([...parcoursPath, 'modules', moduleId ?? this.moduleSelected()!.id]);
    }
  }
}
